import { AxiosPromise } from 'axios';

const unwrapFromAxiosPromise = <T = any>(axiosPromise: AxiosPromise<T>) => {
    return axiosPromise
        .then((resp) => resp.data)
        .catch((error) => Promise.reject(error));
};

const getOptionsFromArgs = (args: any[]) => {
    return args[args.length - 1];
};

export const RequestHelper = {
    unwrapFromAxiosPromise,
    getOptionsFromArgs,
};
